"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function AboutSection() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const imageRef = useRef<HTMLDivElement>(null);
  const [scrollOffset, setScrollOffset] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (imageRef.current) {
        const rect = imageRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        if (rect.top < viewportHeight && rect.bottom > 0) {
          const progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
          setScrollOffset(progress * 10);
        }
      }
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section ref={sectionRef} className="relative py-20 md:py-32 bg-background overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          {}
          <div className={`lg:col-span-7 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-foreground mb-6">
              À propos de JokerStudio
            </h2>
            
            <div className="space-y-4 text-base md:text-lg text-muted-foreground leading-relaxed">
              <p>
                JokerStudio est votre partenaire créatif de confiance pour capturer et immortaliser vos moments les plus précieux. 
                Basée à Montréal, notre agence se spécialise dans la vidéographie professionnelle, la photographie de haute qualité 
                et les services DJ pour vos événements.
              </p>
              
              <p>
                Que vous soyez un particulier cherchant à documenter un moment spécial ou une entreprise souhaitant renforcer votre 
                image de marque, nous mettons notre expertise et notre passion au service de votre vision. Chaque projet est une 
                opportunité de créer quelque chose d'unique et mémorable.
              </p>
              
              <p>
                Notre approche combine créativité cinématographique, professionnalisme et une attention méticuleuse aux détails. 
                Nous croyons que chaque histoire mérite d'être racontée avec authenticité et style.
              </p>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:col-span-5 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
          transform: `translateY(${scrollOffset}px)`,
          transition: "transform 0.1s ease-out"
        }}>
            <div className="relative aspect-[4/5] rounded-lg overflow-hidden shadow-strong">
              <img src="https://profound-bir.10web.cloud/wp-content/uploads/2026/01/def4b289-1.jpg" alt="JokerStudio équipe créative au travail" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent pointer-events-none" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}